import { AUDIT_SAVE_INSPECTION_ITEMS } from "../../types";


export function auditSaveinspections(inspections) {
    return {
        type: AUDIT_SAVE_INSPECTION_ITEMS,
        inspections
    };
}
